import { compose } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { SEARCH } from '../../../constants/formNamesConstants';
import { cabinClasses } from '../../../constants/cabinClassesConstants';
import { tripTypes } from '../../../constants/tripTypesConstants';
import {
  CABIN_CLASS,
  CARRIER_CODES,
  DIRECT_FLIGHT,
  MULTI_BOUND,
  PASSENGERS_FORM_SECTION,
  TRIP_TYPE,
  passengerFields,
  SINGLE_BOUND,
  stopoverFields,
} from '../constants/formFields';
import { CHILD_AGE_DEFAULT_VALUE, MAX_INFANT_AGE, MAX_PASSENGERS } from '../constants/passengers';
import SearchForm from '../components/SearchForm';

const searchDefaultValue = {
  [CABIN_CLASS]: cabinClasses.ECONOMY,
  [CARRIER_CODES]: [],
  [SINGLE_BOUND]: {},
  [MULTI_BOUND]: [{}, {}],
  [PASSENGERS_FORM_SECTION]: {
    [passengerFields.ADULTS]: 1,
    [passengerFields.CHILDREN]: 0,
    [passengerFields.CHILDREN_AGES]: Array(MAX_PASSENGERS).fill(CHILD_AGE_DEFAULT_VALUE),
    [passengerFields.INFANTS]: 0,
    [passengerFields.INFANTS_AGES]: Array(MAX_PASSENGERS).fill(MAX_INFANT_AGE),
  },
  [TRIP_TYPE]: tripTypes.RETURN,
  [stopoverFields.ENABLED]: false,
  [stopoverFields.ONE_DAY]: false,
  [stopoverFields.ONE_NIGHT]: false,
  [stopoverFields.SHORT]: false,
  [stopoverFields.TWO_NIGHTS]: false,
};

const mapStateToProps = (
  state,
  { search = searchDefaultValue, rebookingData, stopoverEnabled },
) => {
  const bounds = formValueSelector(SEARCH)(state, MULTI_BOUND);

  return {
    selectedTripType: formValueSelector(SEARCH)(state, TRIP_TYPE),
    numberOfBounds: bounds?.length,
    initialValues: {
      [CABIN_CLASS]: search.cabinClass,
      [CARRIER_CODES]: search.carrierCodes,
      [DIRECT_FLIGHT]: search.directFlight,
      [MULTI_BOUND]: search.multiBound,
      [PASSENGERS_FORM_SECTION]: rebookingData
        ? rebookingData.initialValues.passengers
        : search.passengers,
      [stopoverFields.ENABLED]: (stopoverEnabled && search.flyRome) || search.stopoverEnabled,
      [stopoverFields.ONE_DAY]: (stopoverEnabled && search.flyRome) || search.oneDayStopover,
      [stopoverFields.ONE_NIGHT]: (stopoverEnabled && search.flyRome) || search.oneNightStopover,
      [stopoverFields.SHORT]: (stopoverEnabled && search.flyRome) || search.shortStopover,
      [stopoverFields.TWO_NIGHTS]: (stopoverEnabled && search.flyRome) || search.twoNightsStopover,
      [SINGLE_BOUND]: search.singleBound,
      [TRIP_TYPE]: search.tripType,
    },
  };
};

const withReduxForm = reduxForm({
  form: SEARCH,
  destroyOnUnmount: false,
  enableReinitialize: true,
});

const connectToStore = connect(mapStateToProps, null);

export default compose(connectToStore, withReduxForm)(SearchForm);
